/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Status_CancelledInputs */

const en_booking_status_cancelled = /** @type {(inputs: Booking_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Booking_Status_CancelledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const booking_status_cancelled = /** @type {((inputs?: Booking_Status_CancelledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Status_CancelledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_booking_status_cancelled(inputs)
});